import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as NoDataSVG } from "../assets/img/no_record.svg";
const NoDataComponent = ({ label }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", my: 2, p: 3 }}>
      <div>
        <NoDataSVG />
        <br />
        <Typography variant="h6" my={0.5}>
          {!!label ? label : "NO RECORD FOUND!"}
        </Typography>
      </div>
    </Box>
  );
};
export default NoDataComponent;
